module.exports = __webpack_public_path__ + "img/kjcg_bd.b5012c6.png";